module.exports = __webpack_public_path__ + "assets/notVeryConfident.1893b794.svg";